<div class="main-div">
    <div class="col-12  flex flex-wrap">
        <h2>صور سياوش</h2>
        <div class="col-12">
            <p>
                صور سیاوش تلفیقی از هنر و نوآوری با الگویی از هندسه و کاربرد گرامافون، به عنوان بلندگوی سرامیکی شناخته و
                استفاده میشود. از صور سیاوش همچنین میتوان به عنوان پایه نگهدارنده گوشی موبایل استفاده کرد.
            </p>
        </div>
        <div class="col-12 ">
            <!--            <video width="100%" controls>-->
            <!--                <source src="{{conf.getBaseUrl()+'lnd/file/stream-video-file?name=gram_sofali.mp4' }}"-->
            <!--                        type="video/mp4">-->
            <!--            </video>-->

            <div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span>
                <iframe src="https://www.aparat.com/video/video/embed/videohash/ksuzl9g/vt/frame" allowFullScreen="true"
                        webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
            </div>
        </div>
    </div>
</div>